import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-achievement',
  templateUrl: './achievement.component.html',
  styleUrls: ['./achievement.component.scss']
})
export class AchievementComponent implements OnInit {

  public coinSum: number;

  coinList = [
    {
      count: 5
    },
    {
      count: 10
    },
    {
      count: 3
    },
    {
      count: 5
    },
    {
      count: 2
    },
    {
      count: 7
    },
    {
      count: 8
    },
    {
      count: 7
    },
    {
      count: 8
    }
  ];

  constructor() { }

  ngOnInit() {

    this.coinSum = this.coinList.reduce( (prev, cur) => prev + cur.count, 0); 

  }

}
